class selectionCtrl {
  constructor($scope, operationService) {
    let activeSel = function () {
      if (operationService.hasPermit('deduction_info')) {
        return 1
      }
      if (operationService.hasPermit('non_deduction_info')) {
        return 2
      }
      if (operationService.hasPermit('deduction_statistics')) {
        return 3
      }
      return -1
    }

    $scope.active = activeSel()
    $scope.typeChange = function typeChange(v) {
      $scope.active = v
    }
  }
}

selectionCtrl.$inject = ['$scope', 'operationService']
export default selectionCtrl



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/selection4th/selectionCtrl.js